@if (showTitle()) {
  <h2 class="report-panel__title">
    <span>{{ subject().subjectName }}</span>

    @if (subject().hasDiagnostic) {
      <span class="report-panel__title-badge">
        {{ subject().score.percentage | reportFmt: 'pct' }}
      </span>
    }
  </h2>
}

@if (subject().hasDiagnostic) {
  <s2e-report-summary [subject]="subject()" />
  <s2e-report-overview [subject]="subject()" />
  <s2e-report-skills [subject]="subject()" />
  <s2e-report-school-levels [subject]="subject()" [scale]="scale()" />
  <s2e-report-insights [subject]="subject()" />
  <s2e-report-levels [subject]="subject()" />
  <s2e-report-ring [subject]="subject()" />
  <s2e-report-weekly [subject]="subject()" [planWeeks]="planWeeks()" />
} @else {
  <!-- Matière affectée, diagnostic pas encore passé. Elle reste au rapport :
       c'est ce qu'il reste à faire, et une matière absente ne le dirait pas.
       Aucun chiffre en revanche — pas même des zéros, qui sanctionneraient un
       test qui n'a pas eu lieu. -->
  <div class="report-panel__pending">
    <i class="fa-solid fa-hourglass-half report-panel__pending-icon" aria-hidden="true"></i>
    <p class="s2e-report-state__title">{{ subject().subjectName }}</p>
    <!-- Clé applicative et non clé du rapport : le bundle du rapport décrit un
         diagnostic passé, il n'a jamais eu à nommer son absence. -->
    <p>{{ 'DIAGNOSTIC_REPORT.NOT_TAKEN' | translate }}</p>
  </div>
}
